<template>
    <div class="main-view" ref="mainView">
        <home-nav class="m-hidden-view"></home-nav>

        <gzh-code-view class="m-hidden-view"></gzh-code-view>

        <div class="m-title" :style="{'height' : titleHeight}" ref="mainTitle">
            <div style="display: flex;height: 70px;align-items: center;justify-content: space-between;width: 100%;">
                <div style="font-size: 16px;color: #666666;user-select: none">
                    <span @click="activePage = 1" :class="activePage === 1 && 'active-title'" style="cursor: pointer;">首页</span>
<!--                    <span @click="activePage = 2" :class="activePage === 2 && 'active-title'" style="margin-left: 15px;cursor: pointer;">预约</span>-->
                </div>
                <img @click="goAppSearch" v-show="showSearchIcon" src="../../assets/search.png" style="width: 25px;height: 25px;margin-right: 15px;" >
            </div>
        </div>

        <div style="width: 100%;min-height: calc(100vh - 380px); max-width: 900px;margin: 0 auto;">
            <div v-if="activePage === 1">
                <div class="p-title" v-if="false" style="width: 100%;background-color: #ffffff;border-radius: 10px;margin-top: 20px;height: fit-content">
                    <div style="height: 70px;padding-left: 50px;display: flex;align-items: center;color: #666666">
                        <span>当前位置：</span>
                        <span style="margin-left: 10px;">首页</span>
                    </div>
                </div>

                <div class="p-hidden-view" :style="{'height' : titleHeight}"></div>
                <div @click="goAppSearch" class="search-input-button p-hidden-view">
                    <img src="../../assets/search.png" style="width: 22px;height: 22px;" >
                    <span style="margin-left: 8px;">{{webConfig.defaultSearchName}}</span>
                </div>

                <div v-if="bannerList.length > 0" class="banner-view p-hidden-view">
                    <van-swipe :autoplay="5000" indicator-color="#ffffff" style="height: 100%;aspect-ratio: 16 / 9">
                        <van-swipe-item v-for="(item,index) in bannerList">
                            <img @click="open(item.gameId)" :src="item.bannerUrl" style="width: 100%;aspect-ratio: 16 / 9"/>
                            <div class="banner-game-view">
                                <img :src="item.gameIcon" style="width: 50px;height: 50px;border-radius: 5px;">
                                <div style="text-align: left;color: #FFFFFF;margin-left: 15px;">
                                    <div style="font-size: 14px;font-weight: bold;">{{item.gameName}}</div>
                                    <div style="font-size: 11px;margin-top: 5px;">
                                        <span v-for="tag in item.tagList">{{tag}}</span>
                                    </div>
                                </div>
                            </div>
                        </van-swipe-item>
<!--                        <template #indicator>
                            <div class="custom-indicator">{{ current + 1 }}/2</div>
                        </template>-->
                    </van-swipe>
                </div>

                <div  class="top-game-view m-hidden-view">
                    <div class="game-video-view" v-for="item in topGameList">
                        <video v-if="!!item.videoUrl" :src="item.videoUrl" style="width: 100%; object-fit:cover;border-radius: 5px;margin-bottom: 20px;"
                               :poster="item.videoImgUrl" :controls="true" :autoplay="false"></video>
                        <div class="game-item-view"  @click="open(item.game_id)">
                            <img :src="item.image_url" style="width: 70px;height: 70px;border-radius: 10px;">
                            <div style="display: flex;height: 70px; margin-left: 15px;flex-direction: column;justify-content: space-between">
                                <span class="game-name-one-line">{{item.game_name}}</span>
                                <div class="game-tag-view">
                                    <span v-for="tag in item.tagList">{{tag}}</span>
                                </div>
                                <div style="font-size: 13px;color: #aaaaaa;text-align: left">
                                    {{handlerTopic(item.game_topic)}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="game-list-view">
                    <div class="game-column-name">
                        <span>热游推荐</span>
                        <img src="../../assets/hot_icon.png" style="width: 20px;margin-left: 10px;">
                        <img src="../../assets/hot_icon.png" style="width: 20px;">
                        <img src="../../assets/hot_icon.png" style="width: 20px;">
                    </div>
                    <div class="game-item-view game-list-item" v-for="item in hotGameList" @click="open(item.game_id)">
                        <img :src="item.image_url" class="game-item-img">
                        <div class="game-item-info">
                            <div style="text-align: left">
                                <span class="game-name-one-line">{{item.game_name}}</span>
                                <span class="m-hidden-view" style="font-size: 13px;color: #aaaaaa;text-align: left;margin-left: 15px;">
                                {{handlerTopic(item.game_topic)}}
                            </span>
                            </div>
                            <div class="game-tag-view">
                                <span v-for="tag in item.tagList">{{tag}}</span>
                            </div>
                            <div class="m-hidden-view" style="font-size: 13px;color: #666666;text-overflow: ellipsis;overflow: hidden;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">
                                {{item.game_desc}}
                            </div>
                            <span class="p-hidden-view" style="font-size: 13px;color: #aaaaaa;text-align: left;">
                                {{handlerTopic(item.game_topic)}}
                        </span>
                        </div>
                    </div>
                </div>

                <div class="game-list-view game-bottom-view">
                    <div class="game-column-name">
                        <span>新游首发</span>
                        <img src="../../assets/new_icon.png" style="width: 40px;margin-left: 10px;">
                    </div>
                    <div class="game-item-view game-list-item" v-for="item in newGameList" @click="open(item.game_id)">
                        <img :src="item.image_url" class="game-item-img">
                        <div class="game-item-info">
                            <div style="text-align: left">
                                <span class="game-name-one-line">{{item.game_name}}</span>
                                <span class="m-hidden-view" style="font-size: 13px;color: #aaaaaa;text-align: left;margin-left: 15px;">
                                {{handlerTopic(item.game_topic)}}
                            </span>
                            </div>
                            <div class="game-tag-view">
                                <span v-for="tag in item.tagList">{{tag}}</span>
                            </div>
                            <div class="m-hidden-view" style="font-size: 13px;color: #666666;text-overflow: ellipsis;overflow: hidden;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">
                                {{item.game_desc}}
                            </div>
                            <span class="p-hidden-view" style="font-size: 13px;color: #aaaaaa;text-align: left;">
                                {{handlerTopic(item.game_topic)}}
                        </span>
                        </div>
                    </div>
                </div>

            </div>

            <div v-if="activePage === 2" >
                <div v-if="newServerGameList.length > 0" style="padding-top: 110px;padding-bottom: 60px;">
                    <div  class="new-server-view" v-for="item in newServerGameList" @click="open(item.game_id)">
                        <img :src="item.image_url" class="game-item-img">
                        <div class="game-item-info" style="overflow: unset;">
                            <div style="text-align: left">
                                <span class="game-name-one-line">{{item.game_name}}</span>
                                <span class="m-hidden-view" style="font-size: 13px;color: #aaaaaa;text-align: left;margin-left: 15px;">
                                    {{handlerTopic(item.game_topic)}}
                                </span>
                            </div>
<!--                            <div class="game-tag-view">
                                <span v-for="tag in item.tagList">{{tag}}</span>
                            </div>-->
                            <span style="font-size: 13px;color: #f8a835;text-align: left;">
                                <span style="padding: 2px 2px;border-radius: 2px;border: 1px solid #f8a835;font-size: 11px;">开服时间</span>
                                <span style="margin-left: 10px;font-weight: bold">{{item.nextServerTime}}</span>
                            </span>
                            <span style="font-size: 13px;color: #ec4a36;text-align: left;font-weight: bold">
                                {{item.nextServerName}}
                            </span>
                        </div>
                    </div>
                </div>

                <div v-else style="margin-top: 200px;color: #888888;font-size: 16px;border-radius: 10px;">
                    暂无数据
                </div>
            </div>


        </div>


        <home-footer class="m-hidden-view"></home-footer>

        <home-tabbar></home-tabbar>

    </div>


</template>

<script>
    import {request} from '@/api/request'
    import {Swipe, SwipeItem, Toast} from 'vant'

    import gzhCodeView from "@/components/home/GzhCodeView";
    import homeNav from "@/components/home/HomeNav";
    import homeFooter from "@/components/home/HomeFooter";
    import homeTabbar from "@/components/home/HomeTabbar";

    import { Tabbar, TabbarItem } from 'vant';
    import Vue from 'vue';
    import config from "@/api/config";
    import notice from "@/api/notice";
    Vue.use(Tabbar);
    Vue.use(TabbarItem);
    Vue.use(Swipe);
    Vue.use(SwipeItem);

    export default {
        name: 'gameHome',
        components: {
            homeNav,
            gzhCodeView,
            homeFooter,
            homeTabbar,
        },
        data() {
            return {
                activePage: 1,
                gameSearchInput: '',
                emptyGameList: false,
                gameList: [],
                bannerList: [],
                topGameList: [],
                hotGameList: [],
                newGameList: [],
                newServerGameList: [],
                webConfig: {},
                showSearchIcon: false,
                titleHeight: '70px',
            }
        },
        watch: {
            activePage(n, o) {
                this.$refs.mainView.scrollTop = 0;
            }
        },
        mounted() {
            this.initPage();
            this.transformChannel();
            this.queryIndexGame();
            if (this.isSafari()) {
                this.safariStyle = 'padding-bottom: 113px';
            }
            if (localStorage.getItem('from') === 'android_box') {
                this.titleHeight = '110px';
            }
        },
        methods: {
            initPage() {
                if (this.$route.query.channelId) {
                    localStorage.setItem('channelId', this.$route.query.channelId);
                }

                if (this.$route.query.from) {
                    localStorage.setItem('from', this.$route.query.from);
                }

                if (this.$route.query.device) {
                    localStorage.setItem('device', this.$route.query.device);
                }

                if (!localStorage.getItem('udid') && this.$route.query.udid) {
                    localStorage.setItem('udid', this.$route.query.udid);
                }
                if (!localStorage.getItem('udid')) {
                    localStorage.setItem('udid', this.generateUUID());
                }

                if (this.$route.query.version) {
                    localStorage.setItem('version', this.$route.query.version);
                }

                this.webConfig = config;
                this.$refs.mainView.addEventListener('scroll', this.onPageScroll);
            },
            transformChannel() {
                let thirdChannel = this.$route.query.thirdChannel || '';
                if (!thirdChannel) {
                    return;
                }
                let options = {
                    url:"/h5/transformChannel?channelConfig=" + thirdChannel,
                    method: 'get',
                };
                request(options).then(res => {
                    if (res.data.success) {
                        let result = res.data.data;
                        console.log('渠道号转化成功，第三方渠道号: ' + thirdChannel + ", 转换结果: " + result);
                        localStorage.setItem("channelId", result);
                    }
                    else {
                        console.log('渠道号转化失败');
                    }
                });
            },
            onPageScroll() {
                let scrollTop = this.$refs.mainView.scrollTop;
                if (scrollTop === 0) {
                    /*this.$refs.mainView.style.background = 'url(' + require('@/assets/m-main-background.png') +')'
                    this.$refs.mainView.style.backgroundSize = '100% 100%'
                    this.$refs.mainTitle.style.backgroundColor = 'unset';*/
                    this.showSearchIcon = false;
                }
                else {
                    /*this.$refs.mainTitle.style.backgroundColor = '#f3f1ef';
                    this.$refs.mainView.style.background = "unset";
                    this.$refs.mainView.style.backgroundColor = "#f3f1ef";*/
                    if (this.activePage === 1) {
                        this.showSearchIcon = true;
                    }
                }
            },
            queryIndexGame() {
                this.showLoading = true;
                let options = {
                    url:"/web/queryIndexGame",
                    method: 'get'
                };
                request(options).then(res => {
                    this.showLoading = false;
                    if (res.data.success) {
                        let data = res.data.data;
                        let left = data.leftInfo;
                        let right = data.rightInfo;
                        if(left) {
                            this.topGameList.push(left);
                        }
                        if(right) {
                            this.topGameList.push(right);
                        }
                        this.hotGameList = data.hotList;
                        this.newGameList = data.newList;
                        this.newServerGameList = data.newServerList;
                        this.bannerList = data.bannerList;
                        //this.newServerGameList.push(data.newServerList[0])
                    }
                    else {
                        Toast(res.data.error.message);
                    }
                });
            },
            handlerTopic(t) {
                switch (t) {
                    case '1':
                        return '卡牌';
                    case '2':
                        return '传奇';
                    case '3':
                        return '武侠';
                    case '4':
                        return '角色';
                    case '5':
                        return '养成';
                    case '6':
                        return '三国';
                    case '7':
                        return '模拟';
                    case '8':
                        return '策略';
                    case '9':
                        return '休闲';
                }
            },
            open(gameId) {
                let channelId = localStorage.getItem('channelId') || 1;
                this.$router.push('/gameInfo/' + channelId + '/' + gameId);
                //this.$router.push('/h5/' + channelId + '/' + gameId);
            },
            isSafari() {
                return (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent));
            },
            goAppSearch() {
                this.$router.push('/home/appSearch');
            },
            generateUUID(){
                let d=new Date().getTime();
                let uuid ='xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            },
        }
    }
</script>
<style scoped>
    .main-view {
        width: 100%;
        height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #f3f1ef;
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .main-view::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }

    .top-game-view {
        display: flex;
        justify-content: space-between;
    }

    .game-video-view {
        width: 430px;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: space-between;
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px 25px 5px;
        box-sizing: border-box;
    }

    .banner-game-view {
        display: flex;
        align-items: center;
        width: 100%;
        height: 60px;
        position: absolute;
        bottom: 0;
        left: 0;
        padding-left: 20px;
        padding-bottom: 5px;
        box-sizing: border-box;
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
        pointer-events: none;
    }

    .game-item-view {
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;
        box-sizing: border-box;
        transition: all 0.15s ease-out;
    }

    .new-server-view {
        width: 90%;
        margin: 10px auto 0;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        box-sizing: border-box;
        background-color: #FFFFFF;
        padding: 10px 15px 5px;
        border-radius: 10px;
    }

    .game-list-item {
        margin-top: 20px;
    }
    .game-item-view:hover .game-name-one-line {
        color: #0e7dde;
    }
    .game-video-view:hover,.game-list-item:hover  {
        transform: translateY(-3px);
    }
    .game-name-one-line {
        width: 300px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        color: #333333
    }
    .game-tag-view {
        display: flex;
        color: #f15858;
        font-size: 12px;
    }
    .game-tag-view span {
        margin-right: 10px;
        background-color: rgba(241, 88, 88, 0.1);
        padding: 2px 4px;
        border-radius: 2px;
        white-space: nowrap;
    }

    .m-title {
        display: none;
        font-size: 26px;
        color: #333333;
        width: 100%;
        text-align: left;
        align-items: flex-end;
        padding: 0 20px;
        position: fixed;
        z-index: 999;
        justify-content: space-between;
        box-sizing: border-box;
        background-color: #f3f1ef;
    }
    .active-title {
        font-size: 26px;
        font-weight: bold;
        color: #333333;
    }
    .game-list-view {
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        border-radius: 10px;
        margin-top: 20px;
        margin-bottom: 20px;
        padding: 20px 25px;
        box-sizing: border-box;
    }

    .game-column-name {
        font-size: 30px;
        font-weight: bold;
        color: #ef3b3b;
        text-align: left;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
    }
    .game-item-img {
        width: 100px;
        height: 100px;
        border-radius: 10px;
    }
    .game-item-info {
        display: flex;
        height: 90px;
        margin-left: 15px;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;
    }
    .search-input-button {
        height: 45px;
        background-color: #ffffff;
        border-radius: 35px;
        margin: 0 25px 0;
        display: flex;
        align-items: center;
        padding: 0 15px;
        color: #aaaaaa;
        font-size: 16px;
    }
    .banner-view {
        width: 100%;
        margin: 10px auto 0;
        overflow: hidden;
        border-radius: 12px;
        position: relative;
    }
    /deep/.van-swipe__indicators {
        left: unset;
        right: 10px;
    }
    @media screen and (max-width: 900px) {
        .main-view {

        }
        .banner-view {
            width: 90%;
        }
        .p-title {
            display: none;
        }

        .m-hidden-view {
            display: none !important;
        }
        .m-title {
            display: flex;
        }
        .top-game-view {
            flex-direction: column;
        }
        .game-video-view {
            width: 90%;
            margin: 10px auto 0;
            padding: 10px 15px 5px;
        }
        .game-list-view {
            width: 90%;
            margin: 10px auto;
            padding: 15px 15px;
        }
        .game-bottom-view {
            margin-bottom: 70px;
        }
        .game-item-img {
            width: 80px;
            height: 80px;
        }
        .game-item-info {
            height: 75px;
        }
        .game-column-name {
            font-size: 22px;
        }
        .game-list-item {
            margin-top: 10px;
        }
    }

    @media screen and (min-width: 900px) {
        .p-hidden-view {
            display: none;
        }
    }
</style>

